import { readWebsiteVariable } from './utils/readWebsiteVariable';

/* eslint-disable */
const awsconfig = {
  aws_project_region: readWebsiteVariable('REACT_APP_aws_project_region'),
  // "aws_cognito_identity_pool_id": readWebsiteVariable(REACT_APP_aws_cognito_identity_pool_id,
  aws_cognito_region: readWebsiteVariable('REACT_APP_aws_cognito_region'),
  aws_user_pools_id: readWebsiteVariable('REACT_APP_aws_user_pools_id'),
  aws_user_pools_web_client_id: readWebsiteVariable(
    'REACT_APP_aws_user_pools_web_client_id'
  ),
  oauth: {}
};

export default awsconfig;
